export const uploadSelectOptions = [
  { value: 1, name: 'Bill of Sales' },
  { value: 2, name: 'Lienholder Documents' },
  { value: 3, name: 'Excel Displaying the Cost of the Asset' },
  { value: 4, name: 'Claim Documents' },
  { value: 5, name: 'A/P Trailer Invoice' },
  { value: 6, name: 'Multiple A/P Accessory Invoices' },
];
